import ConfirmedMeetingsTable from './ConfirmedMeetingsTable'

export default ConfirmedMeetingsTable
